<template>
  <v-container>
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="2500" top>
      {{ snackbar.message }}
    </v-snackbar>

    <v-dialog v-model="detailDialog" max-width="920">
      <v-card>
        <v-card-title class="text-h6">已发送邮件</v-card-title>
        <v-card-text v-if="detailLoading" style="padding: 32px; text-align: center;">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
          <div style="margin-bottom: 8px;"><strong>发件人：</strong>{{ detail.from_addr }}</div>
          <div style="margin-bottom: 8px;"><strong>收件人：</strong>{{ detail.to_addr }}</div>
          <div style="margin-bottom: 8px;"><strong>主题：</strong>{{ detail.subject }}</div>
          <div style="margin-bottom: 8px;"><strong>时间：</strong>{{ detail.mail_time }}</div>
          <div style="margin-bottom: 8px;"><strong>状态：</strong>{{ detail.respond_code }} {{ detail.respond_msg }}</div>
          <v-divider style="margin: 16px 0;"></v-divider>
          <div v-if="detail.body" v-html="detail.body" style="min-height: 180px; word-break: break-word;"></div>
          <div v-else style="min-height: 180px; color: #666;">暂无正文备份</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="detailDialog = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <h3 style="padding-bottom: 20px;">发送列表</h3>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="查找"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="maillist"
            :search="search"
            :loading="loading"
            :server-items-length="totalCnt"
            :options.sync="options"
            :footer-props="{
              itemsPerPageOptions: [50, 100],
              'items-per-page-text': '每页展示',
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-chevron-left',
              nextIcon: 'mdi-chevron-right'
            }"
          >
            <template v-slot:[`item.subject`]="{ item }">
              <div
                style="padding: 3px; cursor: pointer; color: #1565c0; font-weight: 600;"
                @click="subjectClick(item)"
              >
                {{ item.subject }}
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: "vSendLogs",

  data: () => ({
    logininfo: {},
    search: '',
    headers: [
      { text: '发件人', value: 'from_addr', width: "180px" },
      { text: '收件人', value: 'to_addr', width: "180px" },
      { text: '内容', value: 'subject' },
      { text: '时间', value: 'mail_time', width: "180px" },
      { text: '状态码', value: 'respond_code', width: "100px" },
    ],
    maillist: [],
    loading: true,
    options: { itemsPerPage: 50, page: 1 },
    totalCnt: 0,
    firstload: true,
    detailDialog: false,
    detailLoading: false,
    detail: {
      from_addr: '',
      to_addr: '',
      subject: '',
      body: '',
      mail_time: '',
      respond_code: '',
      respond_msg: ''
    },
    snackbar: {
      show: false,
      message: '',
      color: 'error'
    }
  }),

  methods: {
    showError(message) {
      this.snackbar.message = message;
      this.snackbar.color = 'error';
      this.snackbar.show = true;
    },

    subjectClick(item) {
      if (!item || !item.id) {
        return;
      }
      this.detailLoading = true;
      this.detailDialog = true;
      axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
      axios.get('/api/sendinglog', { params: { id: item.id } }).then(response => {
        if (response.status === 200 && response.data.code === 200) {
          this.detail = response.data.data || {};
        } else {
          this.detailDialog = false;
          this.showError(response.data.message || '加载发送备份失败');
        }
      }).catch(error => {
        console.log("subjectClick error", error);
        this.detailDialog = false;
        this.showError('加载发送备份失败');
      }).finally(() => {
        this.detailLoading = false;
      });
    },

    loadData: async function () {
      this.loading = true;
      let pageId = this.options.page;
      let pageNum = this.options.itemsPerPage;

      axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
      axios.get('/api/sendinglogs?page_index=' + pageId + "&page_size=" + pageNum).then(response => {
        this.maillist = [];
        if (response.status == 200 && response.data.code == 200) {
          let mylist = response.data.data || [];
          for (let i in mylist) {
            let citem = {};
            citem.id = mylist[i].id;
            citem.message_id = mylist[i].message_id;
            citem.from_addr = mylist[i].from_addr;
            citem.to_addr = mylist[i].to_addr;
            citem.mail_time = mylist[i].mail_time;
            citem.subject = mylist[i].subject;
            citem.respond_code = mylist[i].respond_code;
            citem.respond_msg = mylist[i].respond_msg;
            this.maillist.push(citem);
          }
          this.totalCnt = response.data.total;
        } else {
          this.showError(response.data.message || '加载发送列表失败');
        }
      }).catch(err => {
        console.log(err);
        this.showError('加载发送列表失败');
      }).finally(() => {
        this.loading = false;
      });
    }
  },

  created: async function () {
    axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
    await axios.get('/api/profile').then(
      response => {
        if (response.status == 200 && response.data.code == 200) {
          this.logininfo = response.data.data;
        } else {
          window.location = '/login';
        }
      }
    )
    .catch(err => {
      window.location = '/login';
      console.log(err);
    });

    await this.loadData();
  },

  watch: {
    options: {
      handler() {
        if (this.firstload) {
          this.firstload = false;
          return;
        }
        this.loadData();
      },
      deep: true,
    },
  }
};
</script>
